'use strict';
function formFeatures() {
    var $ = jQuery;
    $('.af-form[data-features]').each(function (i, form) {
        var features = $(form).data('features').split(' ');
        var draftHandler = function () {
            $(form).append($('<input type="hidden" name="draft" value="1" />'));
        };
        for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
            var feature = features_1[_i];
            switch (feature) {
                // Add a "Save Draft" button to the submission area
                case 'draft':
                    var $submitArea = $(form).find('.af-submit');
                    var $draftSubmit = $submitArea.find(':submit').clone();
                    $draftSubmit
                        .addClass('af-submit-draft')
                        .attr('id', 'save-post') // ACF looks for this ID to skip validation
                        .text('Save Draft')
                        .on('click', draftHandler);
                    $submitArea.find(':submit:first').after($draftSubmit);
                    break;
            }
        }
    });
}
//# sourceMappingURL=form-features.js.map